import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63114e3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pb-16" }
const _hoisted_2 = { class: "mb-12 layout-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { ref } from 'vue';
import { useRoute } from 'vue-router';

import BalAccordion from '@/components/_global/BalAccordion/BalAccordion.vue';
// Components
import MyPoolBalancesCard from '@/components/cards/MyPoolBalancesCard/MyPoolBalancesCard.vue';
import MyWalletTokensCard from '@/components/cards/MyWalletTokensCard/MyWalletTokensCard.vue';
import Col3Layout from '@/components/layouts/Col3Layout.vue';
import usePoolTransfers from '@/composables/contextual/pool-transfers/usePoolTransfers';
import usePoolTransfersGuard from '@/composables/contextual/pool-transfers/usePoolTransfersGuard';
// Composables
import useBreakpoints from '@/composables/useBreakpoints';
import { useReturnRoute } from '@/composables/useReturnRoute';
import StakingProvider from '@/providers/local/staking/staking.provider';

/**
 * STATE
 */

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const id = ref<string>(route.params.id as string);

/**
 * COMPOSABLES
 */
const { getReturnRoute } = useReturnRoute();
const { upToLargeBreakpoint } = useBreakpoints();
const { pool, loadingPool, useNativeAsset, transfersAllowed } =
  usePoolTransfers();
usePoolTransfersGuard();

return (_ctx: any,_cache: any) => {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(StakingProvider), {
    poolAddress: _unref(pool)?.address
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_BalBtn, {
            tag: "router-link",
            to: _unref(getReturnRoute)({ name: 'pool', params: { id: id.value } }),
            color: "white",
            circle: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_BalIcon, {
                name: "x",
                size: "lg"
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createVNode(Col3Layout, {
          offsetGutters: "",
          mobileHideGutters: ""
        }, _createSlots({
          default: _withCtx(() => [
            _createVNode(_component_router_view, {
              key: _ctx.$route.path
            }),
            (_unref(upToLargeBreakpoint))
              ? (_openBlock(), _createBlock(BalAccordion, {
                  key: 0,
                  class: "mt-4",
                  sections: [
            {
              title: _ctx.$t('poolTransfer.myWalletTokensCard.title'),
              id: 'myWalletTokens',
            },
            {
              title: _ctx.$t('poolTransfer.myPoolBalancesCard.title'),
              id: 'myPoolBalances',
            },
          ]
                }, {
                  myWalletTokens: _withCtx(() => [
                    (_unref(loadingPool) || !_unref(pool) || !_unref(transfersAllowed))
                      ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                          key: 0,
                          class: "h-64"
                        }))
                      : (_openBlock(), _createBlock(MyWalletTokensCard, {
                          key: 1,
                          useNativeAsset: _unref(useNativeAsset),
                          "onUpdate:useNativeAsset": _cache[1] || (_cache[1] = ($event: any) => (_isRef(useNativeAsset) ? (useNativeAsset).value = $event : null)),
                          pool: _unref(pool),
                          hideHeader: "",
                          noBorder: "",
                          square: ""
                        }, null, 8, ["useNativeAsset", "pool"]))
                  ]),
                  myPoolBalances: _withCtx(() => [
                    (_unref(loadingPool) || !_unref(pool) || !_unref(transfersAllowed))
                      ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                          key: 0,
                          class: "h-64"
                        }))
                      : (_openBlock(), _createBlock(MyPoolBalancesCard, {
                          key: 1,
                          pool: _unref(pool),
                          hideHeader: "",
                          noBorder: "",
                          square: ""
                        }, null, 8, ["pool"]))
                  ]),
                  _: 1
                }, 8, ["sections"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, [
          (!_unref(upToLargeBreakpoint))
            ? {
                name: "gutterLeft",
                fn: _withCtx(() => [
                  (_unref(loadingPool) || !_unref(transfersAllowed) || !_unref(pool))
                    ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                        key: 0,
                        class: "h-64"
                      }))
                    : (_openBlock(), _createBlock(MyWalletTokensCard, {
                        key: 1,
                        useNativeAsset: _unref(useNativeAsset),
                        "onUpdate:useNativeAsset": _cache[0] || (_cache[0] = ($event: any) => (_isRef(useNativeAsset) ? (useNativeAsset).value = $event : null)),
                        pool: _unref(pool)
                      }, null, 8, ["useNativeAsset", "pool"]))
                ])
              }
            : undefined,
          (!_unref(upToLargeBreakpoint))
            ? {
                name: "gutterRight",
                fn: _withCtx(() => [
                  (_unref(loadingPool) || !_unref(pool) || !_unref(transfersAllowed))
                    ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                        key: 0,
                        class: "h-64"
                      }))
                    : (_openBlock(), _createBlock(MyPoolBalancesCard, {
                        key: 1,
                        pool: _unref(pool)
                      }, null, 8, ["pool"]))
                ])
              }
            : undefined
        ]), 1024)
      ])
    ]),
    _: 1
  }, 8, ["poolAddress"]))
}
}

})